// ── Almacén offline de datos (IndexedDB) ──────────────────────────────────────
// La última semana CON datos viaja en el teléfono. Antes esto dependía del
// service worker (caché de /api), pero en el WebView de Android la clave de la
// lista de sesiones cambiaba cada día (since=ahora−N) → al abrir sin señal la
// app no encontraba nada y tiraba "Failed to fetch". Acá los datos se guardan
// con claves FIJAS (una por fecha) en IndexedDB, que el WebView soporta bien.
// Todo es best-effort: si IndexedDB no está (modo privado viejo), cada función
// devuelve null y la app sigue como si no hubiera copia local.

const DB_NAME = 'manabi-offline'
const STORE   = 'kv'

let _db = null
function openDb() {
  if (_db) return _db
  _db = new Promise((resolve, reject) => {
    try {
      const req = indexedDB.open(DB_NAME, 1)
      req.onupgradeneeded = () => { req.result.createObjectStore(STORE) }
      req.onsuccess = () => resolve(req.result)
      req.onerror   = () => reject(req.error)
    } catch (e) { reject(e) }
  })
  _db.catch(() => { _db = null })
  return _db
}

function tx(mode, fn) {
  return openDb().then(db => new Promise((resolve, reject) => {
    const t = db.transaction(STORE, mode)
    const r = fn(t.objectStore(STORE))
    t.oncomplete = () => resolve(r.result)
    t.onerror    = () => reject(t.error)
    t.onabort    = () => reject(t.error)
  }))
}

export const oset  = (key, value) => tx('readwrite', s => s.put({ v: value, ts: Date.now() }, key)).catch(() => null)
export const oget  = (key) => tx('readonly', s => s.get(key)).then(r => r ? r.v : null).catch(() => null)
export const odel  = (key) => tx('readwrite', s => s.delete(key)).catch(() => null)
export const okeys = () => tx('readonly', s => s.getAllKeys()).then(k => k || []).catch(() => [])
export const oclear = () => tx('readwrite', s => s.clear()).catch(() => null)

// ── Claves por usuario (para que otra cuenta en el mismo teléfono no vea nada ajeno) ──
// Mismo criterio que las claves de caché en memoria de la app: user.id primero.
export const uidOf = (u) => u?.id ?? u?.email ?? 'anon'
const dayKey      = (uid, fecha) => `day:${uid}:${fecha}`
const sessionsKey = (uid) => `sessions:${uid}`

/** Guarda las lecturas + anotaciones de un día (formato crudo del servidor). */
export const saveDayOffline = (uid, fecha, data) => oset(dayKey(uid, fecha), data)

/** Copia local de un día, o null si ese día no viajó al teléfono. */
export const loadDayOffline = (uid, fecha) => oget(dayKey(uid, fecha))

/** Guarda la lista de sesiones (formato crudo del servidor). */
export const saveSessionsOffline = (uid, sessions) => oset(sessionsKey(uid), { sessions })

/** Lista de sesiones guardada, o null. */
export const loadSessionsOffline = (uid) => oget(sessionsKey(uid)).then(d => d?.sessions || null)

/** Borra los días de este usuario que ya no están entre los elegidos. */
export async function pruneDaysOffline(uid, keepFechas) {
  const keep = new Set(keepFechas.map(f => dayKey(uid, f)))
  const keys = await okeys()
  for (const k of keys) {
    if (typeof k === 'string' && k.startsWith(`day:${uid}:`) && !keep.has(k)) await odel(k)
  }
}
